import { agentEditorCopy } from '@/copy'
import type { CompactionState } from '@/types/editor'
import { Field, Input, Select } from '@/ui/Field/Field'
import { Stack } from '@/ui/layout/Stack'
import { SectionHeader } from '@/ui/SectionHeader/SectionHeader'
import { DEFAULT_COMPACTION } from './serialization'

interface CompactionConfigSectionProps {
  state: CompactionState
  onChange: (v: CompactionState) => void
}

export function CompactionConfigSection({
  state,
  onChange,
}: CompactionConfigSectionProps) {
  const overrides = (
    Object.keys(DEFAULT_COMPACTION) as (keyof CompactionState)[]
  ).filter((k) => state[k] !== DEFAULT_COMPACTION[k]).length
  const summary =
    overrides === 0
      ? agentEditorCopy.compaction.usingDefaults
      : agentEditorCopy.compaction.overridden(overrides)

  return (
    <Stack gap="space-16">
      <SectionHeader>
        {agentEditorCopy.compaction.heading(summary)}
      </SectionHeader>
      <Stack gap="space-16">
        <Field
          id="af-cmp-ctx"
          help={agentEditorCopy.compaction.maxContextTokensHelp}
          label={agentEditorCopy.compaction.maxContextTokens}
        >
          <Input
            type="number"
            min={1}
            value={state.max_context_tokens}
            onChange={(e) =>
              onChange({ ...state, max_context_tokens: e.target.value })
            }
            placeholder={agentEditorCopy.compaction.unlimited}
          />
        </Field>
        <Field
          id="af-cmp-recent"
          label={agentEditorCopy.compaction.preserveRecent}
        >
          <Input
            type="number"
            min={0}
            value={state.preserve_recent}
            onChange={(e) =>
              onChange({ ...state, preserve_recent: e.target.value })
            }
          />
        </Field>
        <Field
          id="af-cmp-tool"
          label={agentEditorCopy.compaction.maxToolResultTokens}
        >
          <Input
            type="number"
            min={1}
            value={state.max_tool_result_tokens}
            onChange={(e) =>
              onChange({ ...state, max_tool_result_tokens: e.target.value })
            }
          />
        </Field>
        <Field
          id="af-cmp-strat"
          label={agentEditorCopy.compaction.summaryStrategy}
        >
          <Select
            value={state.summary_strategy}
            onChange={(e) =>
              onChange({
                ...state,
                summary_strategy: e.target
                  .value as CompactionState['summary_strategy'],
              })
            }
          >
            <option value="marker">{agentEditorCopy.compaction.marker}</option>
            <option value="llm_summary">
              {agentEditorCopy.compaction.llmSummary}
            </option>
            <option value="episode_summary">
              {agentEditorCopy.compaction.episodeSummary}
            </option>
          </Select>
        </Field>
      </Stack>
    </Stack>
  )
}
